export default "__VITE_ASSET__Bg8UbVh0__"